export default __webpack_public_path__ + "static/5-kootenay-label-8a3905db0bcda42c65264117d29b3faf.svg";